import { render, staticRenderFns } from "./creatDialog.vue?vue&type=template&id=763979e9&scoped=true"
import script from "./creatDialog.vue?vue&type=script&lang=js"
export * from "./creatDialog.vue?vue&type=script&lang=js"
import style0 from "./creatDialog.vue?vue&type=style&index=0&id=763979e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763979e9",
  null
  
)

export default component.exports